export default __webpack_public_path__ + "static/media/devguide08.a7bf1005.md";